import { client } from "api/client";
import * as actions from "modules/common/store/actions";
import * as utility from "utilities/utils";
import { ENDPOINTS } from "utilities/endPoints";

export default function updateQuoteLetter(params) {

    return async (dispatch) => {
        const url = `${process.env.REACT_APP_QUOTE_PROCESSOR}${ENDPOINTS.QUOTE_PROCESSOR.QUOTE_LETTER_UPDATE}` ;
        

        return await client.put(url, params).then((response) => {

            return dispatch({
                type: actions.GET_QUOTE_LETTER_UPDATE_SUCCESS,
                payload: utility.getResponse(response)
            });

        })
            .catch((error) => {

                return dispatch({
                    type: actions.GET_QUOTE_LETTER_UPDATE_FAIL,
                    payload: utility.getErrorResponse(error)
                });

            });


    };

}
